import * as React from 'react';
import {getAssetPath} from '../../../utils/DieselUtils';
import {breakpoints, video} from '../../../constants';

import {FileType} from '../../../models/Files';
import {getFileTypeFromUrl} from '../../../utils/GeneralUtils';

import Picture from '../../picture/Picture';

import {Source} from '../../video/types';
import Video from '../../video/Video';

// @ts-ignore
import styles from '../Markdown.pcss';

const MarkdownImage = (props: {alt: string; title: string; src: string}) => {
    const fileType: FileType = getFileTypeFromUrl(props.src);
    if (fileType === FileType.UNSUPPORTED) return;

    const assetPath: string = getAssetPath(props.src);

    if (fileType === FileType.IMAGE) {
        return (
            <>
                <Picture
                    title={props.alt}
                    className={styles.image}
                    lazy
                    srcSet={{
                        [breakpoints.name.XSMALL]: assetPath
                    }}
                />
                {props.title && <caption>{props.title}</caption>}
            </>
        );
    }

    const videoSource: Source = {
        src: assetPath,
        type: video[fileType.toUpperCase()]
    };

    return (
        <>
            <Video
                hasControls={true}
                loop={true}
                muted={true}
                sources={[videoSource]}
                title={props.alt}
                type={video.types.HTML}
            />
            {props.title && <caption>{props.title}</caption>}
        </>
    );
};

export default MarkdownImage;
